import { ProjectCardRebrand } from 'src/components/molecules/ProjectCardRebrand'

import { viewProjectDetailPath } from 'src/config/paths'
import { env } from 'src/env/client.mjs'
import { ListProjectsType } from 'src/types/project'

export interface ProjectsTableProps {
  projectsData: ListProjectsType[]
}

export const ProjectsTable = ({ projectsData }: ProjectsTableProps) => {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
      {projectsData?.map(project => (
        <ProjectCardRebrand
          key={project.Id}
          name={project.Name ?? ''}
          imageUrl={
            project.Hero
              ? `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${project.Hero}`
              : undefined
          }
          location={project.Region?.Name ?? undefined}
          treeCount={project.TreesApproved ?? 0}
          href={viewProjectDetailPath({
            routeParams: {
              projectId: project.Id
            }
          })}
        />
      ))}
    </div>
  )
}
